import React, { useState } from "react";
import { toast } from "sonner";
import { Switch } from "../ui/switch";
import { http, formatApiError } from "../resources/resourceUtils";

const inputCls = "w-full rounded-xl border px-4 py-3 text-[16px] bg-white focus:outline-none focus:border-[#8A9470]";
const Card = ({ title, children, testid }) => (
    <section className="res-card p-7 lg:p-8" data-testid={testid}>
        <h2 className="font-serif text-[26px]" style={{ color: "#4A4A30" }}>{title}</h2>
        <div className="mt-5 space-y-4">{children}</div>
    </section>
);

const save = async (body, msg, onChanged) => {
    try { await http.put("/admin/resource-settings", body); toast.success(msg); onChanged(); } catch (e) { toast.error(formatApiError(e)); }
};

const PasswordCard = () => {
    const [cur, setCur] = useState("");
    const [next, setNext] = useState("");
    const submit = async (e) => {
        e.preventDefault();
        try {
            await http.post("/admin-auth/change-password", { current_password: cur, new_password: next });
            setCur(""); setNext(""); toast.success("Password changed");
        } catch (err) { toast.error(formatApiError(err)); }
    };
    return (
        <Card title="Change your password" testid="admin-settings-password">
            <form onSubmit={submit} className="space-y-4">
                <label className="block text-[15px]">Current password
                    <input type="password" autoComplete="current-password" className={`${inputCls} mt-2`} style={{ borderColor: "#E8E4DA" }} value={cur} onChange={(e) => setCur(e.target.value)} required data-testid="admin-settings-current-password" />
                </label>
                <label className="block text-[15px]">New password (at least 10 characters)
                    <input type="password" autoComplete="new-password" minLength={10} className={`${inputCls} mt-2`} style={{ borderColor: "#E8E4DA" }} value={next} onChange={(e) => setNext(e.target.value)} required data-testid="admin-settings-new-password" />
                </label>
                <button type="submit" className="res-btn" data-testid="admin-settings-password-save">Change password</button>
            </form>
        </Card>
    );
};

export const SettingsPanel = ({ settings, onChanged }) => {
    const [intro, setIntro] = useState(settings.intro || "");
    const [code, setCode] = useState(settings.access_code || "");
    return (
        <div className="grid gap-8 lg:grid-cols-2 items-start" data-testid="admin-settings">
            <Card title="Page introduction" testid="admin-settings-intro">
                <label htmlFor="intro" className="sr-only">Introduction text</label>
                <textarea id="intro" rows={5} className={inputCls} style={{ borderColor: "#E8E4DA" }} value={intro} onChange={(e) => setIntro(e.target.value)} maxLength={1200} data-testid="admin-settings-intro-input" />
                <button type="button" className="res-btn" onClick={() => save({ intro }, "Introduction saved", onChanged)} data-testid="admin-settings-intro-save">Save introduction</button>
            </Card>
            <Card title="Client access code" testid="admin-settings-access">
                <label className="flex items-center gap-3 text-[16px]">
                    <Switch checked={!!settings.access_code_enabled} onCheckedChange={(v) => save({ access_code_enabled: v }, v ? "Access code turned on" : "Resources are now open to everyone", onChanged)} data-testid="admin-settings-access-toggle" />
                    {settings.access_code_enabled ? "On: visitors need the code" : "Off: the page is open to everyone"}
                </label>
                <label htmlFor="access-code-admin" className="block text-[15px]">Shared code</label>
                <input id="access-code-admin" className={inputCls} style={{ borderColor: "#E8E4DA" }} value={code} onChange={(e) => setCode(e.target.value)} minLength={3} maxLength={60} data-testid="admin-settings-access-code" />
                <button type="button" className="res-btn" disabled={code.trim().length < 3} onClick={() => save({ access_code: code }, "Access code updated", onChanged)} data-testid="admin-settings-access-save">Save code</button>
                <p className="text-[14px] leading-[1.6]" style={{ color: "#7D7D68" }}>When you change the code, everyone will need the new one. No visitor details are stored.</p>
            </Card>
            <PasswordCard />
        </div>
    );
};
